<template>
    <!-- App Header -->
    <SideHeader :indexPage="true" />

    <!-- * App Header -->

    <!-- Extra Header -->
    <div class="extraHeader">
        <ul class="nav nav-tabs lined" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" data-bs-toggle="tab" href="#ticket" role="tab">
                    اعلان ثبت بار
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#archive" role="tab">
                    اعلان های شخصی
                </a>
            </li>
        </ul>
    </div>
    <!-- * Extra Header -->

    <!-- App Capsule -->
    <div style="padding-top: 55px;" class="extra-header-active">

        <div class="tab-content mt-1">
            <!-- ticket tab -->
            <div class="tab-pane fade show active" id="ticket" role="tabpanel">
                <div class="section full mt-2 mb-2">
                    <div class="wide-block pb-2" style="margin-top: 4rem;">

                        <!-- comment block -->
                        <div class="comment-block">
                            <div v-if="publicItems.length > 0">
                                <div v-for="(item, index) in publicItems" :key="index">
                                    <NotificationBox @toggle-read="updateReadNotification" :item="item" />
                                </div>
                            </div>

                            <!-- نمایش پیام خالی بودن -->
                            <div v-else class="d-flex justify-content-center">
                                <div class="alert alert-info text-center shadow-sm w-100" role="alert">
                                    <!-- <i class="bi bi-inbox"></i> -->
                                    <strong>هیچ آیتمی پیدا نشد!</strong>
                                </div>
                            </div>
                        </div>
                        <!-- * comment block -->
                    </div>
                </div>
            </div>
            <!-- * ticket tab -->



            <!-- archive tab -->
            <div class="tab-pane fade" id="archive" role="tabpanel">
                <div class="section full mb-2">
                    <div class="wide-block pb-2" style="margin-top: 4rem;">

                        <!-- comment block -->
                        <div class="comment-block">
                            <div v-for="(item, index) in privateItems" :key="index">
                                <NotificationBox @toggle-read="updateReadNotification" :item="item" />
                            </div>
                        </div>
                        <!-- * comment block -->
                    </div>


                </div>
            </div>
            <!-- * archive tab -->
        </div>
    </div>
    <!-- * App Capsule -->
</template>

<script>
import axios from "axios";
import NotificationBox from '@/components/NotificationBox.vue';
import SideHeader from "@/components/SideHeader.vue";
export default {
    name: "Support",
    data() {
        return {
            postData: {
                role: "driver",
                name: "",
                lastName: "",
                message: "",
                mobileNumber: "",
                email: "driver.gmail.com",
            },
            loading: false,
            privateItems: [],
            publicItems: [],
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            }
        };
    },
    methods: {
        updateReadNotification(itemId) {
            axios.put(`https://core.iran-tarabar.ir/api/driver/notification/${itemId}`, {
                isRead: 1,
            }, this.axiosConfig);

            // پیدا کردن در publicItems
            let notification = this.publicItems.find(n => n.id === itemId);

            if (notification) {
                notification.isRead = 1;
                return;
            }

            // اگر در publicItems نبود، در privateItems جستجو کن
            notification = this.privateItems.find(n => n.id === itemId);
            if (notification) {
                notification.isRead = 1;
            }


        },
        getNotification() {
            axios.get("https://core.iran-tarabar.ir/api/driver/notification", this.axiosConfig)
                .then((response) => {
                    this.privateItems = response.data.data.private
                    this.publicItems = response.data.data.public
                });
        },
    },

    mounted() {
        this.getNotification();
    },
    components: { SideHeader, NotificationBox }
};
</script>

<style scoped>
.bg-header {
    background-color: #e1e1e14a;
}
</style>